<script>
import {mapState} from "vuex";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: null,
      familySize: 2,
      familySizeString: '2',
    };
  },

  computed: {
    ...mapState([
      'fieldsFromUrl',
      'fieldsFromStorage',
    ])
  },

  created() {
    if (this.prepare) {
      if (this.fieldsFromUrl['family_size']) {
        this.familySize = parseInt(this.fieldsFromUrl['family_size'])
      } else if (this.fieldsFromStorage["family_size"]) {
        this.familySize = parseInt(this.fieldsFromStorage['family_size'])
      }

      const valid = this.validate();

      if (valid && (this.fieldsFromUrl['family_size'] || this.fieldsFromStorage["family_size"])) {
        this.setAnswersAndGoToNext()
        return
      }

      this.$emit('show-this-step')
    }
  },

  methods: {
    setAnswer(answer) {
      this.loading = null
      this.loading = answer;
      this.setAnswersAndGoToNext();
    },

    setAnswersAndGoToNext() {
      this.$store.dispatch("setAnswers", [
        {
          field: "family_size",
          value: this.familySize,
        },
      ]);
      this.$emit("next-step");
    },

    validate() {
      return !(!this.familySize || this.familySizeString.length === 0 || !(this.familySize >= 1 && this.familySize < 20));
    },

    handleChange() {
      let val = String(this.familySize);
      if (val === "8") {
        val = val + "+"
      }
      this.familySizeString = val
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">
          How many family members are in your household?
        </h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('Continue')"
        >
          <h2 class="question pt-5">{{ familySizeString }}</h2>
          <b-field class="pt-4">
            <b-slider
              size="is-large"
              :min="1"
              :max="8"
              v-model="familySize"
              @input="handleChange"
              :tooltip="false"
              rounded
            ></b-slider>
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-3"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
